<template>
  <v-app>
    <v-navigation-drawer app fixed v-model="showmobilemenu" v-if="!$vuetify.breakpoint.mdAndUp">
      <v-layout column justify-space-between>
        <v-btn color="blue lighten-5" block to="/">Hjem</v-btn>
        <v-btn color="blue lighten-5" block to="/news">Nyheter</v-btn>
        <v-btn
          color="blue lighten-5"
          block
          to="/tm"
          @click="refreshTrainingModules"
        >Kurs og opplæring</v-btn>
        <v-btn color="blue lighten-5" block to="/contact">Webskjema</v-btn>

        <v-btn
          color="blue lighten-5"
          block
          href="https://followup.dev.prios.no/#/login"
          target="_blank"
        >Gå til follow-up</v-btn>
      </v-layout>
    </v-navigation-drawer>
    <v-container>
      <div v-if="$vuetify.breakpoint.mdAndUp">
        <v-layout row justify-space-between>
          <v-btn color="blue lighten-5" block to="/">Hjem</v-btn>
          <v-btn color="blue lighten-5" block to="/news">Nyheter</v-btn>
          <v-btn
            color="blue lighten-5"
            block
            to="/tm"
            @click="refreshTrainingModules"
          >Kurs og opplæring</v-btn>
          <v-btn color="blue lighten-5" block to="/contact">Webskjema</v-btn>
          <v-btn
            color="blue lighten-5"
            block
            href="https://followup.dev.prios.no/#/login"
            target="_blank"
          >Gå til follow-up</v-btn>
        </v-layout>
      </div>
      <v-toolbar app v-if="$vuetify.breakpoint.smAndDown">
        <v-toolbar-items>
          <v-btn
            class="font-weight-light"
            @click="showmobilemenu = !showmobilemenu"
            large
            flat
            icon
          >
            <v-icon>menu</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-content>
        <router-view></router-view>
      </v-content>
      <v-footer app :fixed="false" :absolute="true">
        <v-container>
          <v-layout style="background-color: rgb(100, 181, 246); height: 100%" wrap>
            <v-spacer></v-spacer>
            <v-flex shrink class="py-3">
              <p>post @ prios.no</p>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
        </v-container>
      </v-footer>
    </v-container>
  </v-app>
  <!-- <router-view /> -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {},
  computed: {
    ...mapGetters(["isLoggedIn", "authStatus", "getUser"])
  },
  data() {
    return {
      showmobilemenu: false,
      images: {
        logo: require("@/assets/ME_Logo.jpg"),
        founderlogo: require("@/assets/Founder_Logo.jpg"),
        fblogo: require("@/assets/f_logo_RGB-Hex-Blue_512.png")
      }
    };
  },
  methods: {
    refreshTrainingModules() {
      if (this.$route.name == "tm") {
        this.$router.go();
      }
    }
  },
  mounted() {
    if (this.isLoggedIn && this.authStatus == "") {
      this.$store
        .dispatch("loginWithToken")
        .then(resp => {
          // setTimeout(() => this.$router.push("/"), 600);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style>
.usynlegbakgrunn {
  background-color: transparent !important;
}
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.resp-container {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
}
#fblogoanimation {
  width: 100px;
  height: 100px;
  position: relative;
  /* animation-name: animation;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-delay: 2s;
  animation-iteration-count: infinite;
  animation-direction: fixed; */
}
@keyframes animation {
  0% {
    right: 0px;
    top: 15px;
  }
  6% {
    right: 0px;
    top: 30px;
  }
  50% {
    right: 180px;
    top: 30px;
  }
  56% {
    right: 180px;
    top: 15px;
  }
  100% {
    right: 0px;
    top: 15px;
  }
}
</style>
